module.exports = __webpack_public_path__ + "img/twbgscq_icon.b5e745f5.png";